import Model, { ID, JsonObject, MODEL_LEVEL } from 'src/models/model'

export default class SiteSchedule extends Model {
  static name = 'SiteSchedule'

  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site, Model.permissionCategories.FilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      startDate: {
        type: String, // Needs to be string because we pass 0000 for the year and it's an invalid date
        default: null
      },
      endDate: {
        type: String, // Needs to be string because we pass 0000 for the year and it's an invalid date
        default: null
      },
      schedule: {
        type: JsonObject,
        default: () => { return {} }
      }
    }
  }

  get openSlotCount () {
    return _(this.schedule).values().map(_.values).flatten().filter().value().length
  }

  get closedSlotCount () {
    return _(this.schedule).values().map(_.values).flatten().filter(v => !v).value().length
  }
}
